import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const SHIPPING_COST = 9.99;
const SANCTIONED_COUNTRIES = ["BY", "CU", "IR", "KP", "RU"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});

  const getProductById = (id) => productData.find((product) => product.id === id);
  const calculateSubtotal = () => cartItems.reduce((total, item) => {
    const product = getProductById(item.id);
    return product ? total + Number(product.price) * item.quantity : total;
  }, 0);

  const createOrderNumber = () => {
    const random = new Uint32Array(2);
    window.crypto.getRandomValues(random);
    return `${Date.now()}${random[0]}${random[1]}`;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const newErrors = {};
    if (!/^\S+@\S+\.\S+$/.test(email)) newErrors.email = "Enter a valid email address";
    if (!countryCode) newErrors.countryCode = "Select a delivery country";
    if (!firstName.trim()) newErrors.firstName = "Enter a first name";
    if (!lastName.trim()) newErrors.lastName = "Enter a last name";
    if (!address.trim()) newErrors.address = "Enter an address";
    if (!city.trim()) newErrors.city = "Enter a city";
    if (!postalCode.trim()) newErrors.postalCode = "Enter a postal code";
    if (!cartItems.length) newErrors.cart = "Your cart is empty";
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    const firstProduct = getProductById(cartItems[0].id);
    const origin = window.location.origin;
    const paymentUrl = new URL("/create_payment.php", origin);
    paymentUrl.search = new URLSearchParams({
      orderNo: createOrderNumber(),
      amount: (calculateSubtotal() + SHIPPING_COST).toFixed(2),
      currency: "USD",
      email,
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: firstProduct.name,
    }).toString();
    window.location.assign(paymentUrl.toString());
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const subtotal = calculateSubtotal();
  const total = subtotal + SHIPPING_COST;

  return (
    <div className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="email">Contact</label>
                <input type="email" id="email" name="email" value={email} placeholder="Email address" onChange={(e) => setEmail(e.target.value)} required />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>
              <div className="form-group">
                <label>Delivery</label>
                <ReactFlagsSelect selected={countryCode} onSelect={setCountryCode} countries={SANCTIONED_COUNTRIES} blacklistCountries searchable className="check-select" />
                {errors.countryCode && <p className="error country-error">{errors.countryCode}</p>}
              </div>
              <div className="form-row">
                <div className="form-group"><input type="text" name="firstName" value={firstName} placeholder="First name *" onChange={(e) => setFirstName(e.target.value)} />{errors.firstName && <p className="error">{errors.firstName}</p>}</div>
                <div className="form-group"><input type="text" name="lastName" value={lastName} placeholder="Last name *" onChange={(e) => setLastName(e.target.value)} />{errors.lastName && <p className="error">{errors.lastName}</p>}</div>
              </div>
              <div className="form-group"><input type="text" name="company" value={company} onChange={(e) => setCompany(e.target.value)} placeholder="Company name (optional)" /></div>
              <div className="form-group"><input type="text" name="address" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Address *" />{errors.address && <p className="error">{errors.address}</p>}</div>
              <div className="form-group"><input type="text" name="address1" value={address1} onChange={(e) => setAddress1(e.target.value)} placeholder="Apartment, suite, etc. (optional)" /></div>
              <div className="form-row">
                <div className="form-group"><input type="text" name="city" value={city} placeholder="City *" onChange={(e) => setCity(e.target.value)} />{errors.city && <p className="error">{errors.city}</p>}</div>
                <div className="form-group"><input type="text" name="postalCode" value={postalCode} placeholder="Postal code *" onChange={(e) => setPostalCode(e.target.value)} />{errors.postalCode && <p className="error">{errors.postalCode}</p>}</div>
              </div>
              <div className="form-group shipping-notice"><label>Shipping method</label><p>Standard tracked shipping</p><strong>$9.99 USD</strong></div>
              <div className="form-group payment-box external-payment-note"><label>Payment</label><p>After selecting Pay Now, you will continue to our secure payment page.</p></div>
              {errors.cart && <p className="error cart-error">{errors.cart}</p>}
              <button type="submit" className="check-checkout-button">Pay Now</button>
            </form>
            <p><Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>Shipping &amp; Returns Info</Link></p>
          </div>
        </div>
        <div className="right">
          <div className="check-order-summary"><div className="check-order-details">
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;
              return <div key={`${item.id}-${index}`} className="check-cart-item">
                <img src={product.image} alt={product.name} /><div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                <div className="check-item-details"><h3>{product.name}{item.size && <><br />Size: {item.size}</>}{item.color && <><br />Color: {item.color}</>}</h3></div>
                <p className="cal-single">${(Number(product.price) * item.quantity).toFixed(2)}</p>
              </div>;
            })}
            <div className="check-summary-details">
              <div className="summary-line"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
              <div className="summary-line"><span>Shipping</span><span>${SHIPPING_COST.toFixed(2)}</span></div>
              <div className="summary-line summary-total"><strong>Total</strong><strong>USD ${total.toFixed(2)}</strong></div>
            </div>
          </div></div>
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
